import DashboardBannerItem from './DashboardBannerItem';

export default DashboardBannerItem;
